import React, { useEffect } from 'react'
import { checkEnv } from '@vt/utils'

const APP_KEY = 'dingpzdudbxdnc6w6poe'
const devUrl = encodeURIComponent('https://ow-dev.survey.work/login?key=syhjws')
const prodUrl = encodeURIComponent('https://ow.survey.work/login?key=syhjws')
const DDLoginContent = function () {
  let url = prodUrl
  if (checkEnv() === 'dev') {
    url = devUrl
  }
  const goto = encodeURIComponent(
    `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${APP_KEY}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${url}`
  )
  useEffect(() => {
    // eslint-disable-next-line no-undef
    DDLogin({
      id: 'login_container',
      goto,
      style: 'border:none;background-color:#FFFFFF;',
      width: '100%',
      height: '300',
    })
  }, [])

  const handleMessage = function (event) {
    const { origin } = event
    console.log('origin', event.origin)
    // 判断是否来自ddLogin扫码事件。
    if (origin === 'https://login.dingtalk.com') {
      const loginTmpCode = event.data
      // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${APP_KEY}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${url}&loginTmpCode=${loginTmpCode}`
    }
  }
  if (typeof window.addEventListener !== 'undefined') {
    window.addEventListener('message', handleMessage, false)
  } else if (typeof window.attachEvent !== 'undefined') {
    window.attachEvent('onmessage', handleMessage)
  }

  return <div id="login_container" className="login_container -mt-4" />
}
export default DDLoginContent
